import { Col, Row } from "antd";
import "@/entities/journal";
import { UserBubble } from "@shared/ui";
import { fallbackString, formatDate, formatDatetime } from "@shared/utils";
import "./section-fourth-control-procedure.scss";

interface SectionFourthControlProcedureProps {
  constructionControlInfo?: string;
  controlEventPeriod?: {
    beginDate?: string;
    endDate?: string;
  };
  defectDescriptionText?: string;
  defectFixingPlanDate?: string;
  locationDescription?: string;
  inspectionEmployee?: {
    inspectionEmployeeId?: string;
    firstName?: string;
    surname?: string;
    middleName?: string;
  };
}

export const SectionFourthControlProcedure = ({
  constructionControlInfo,
  controlEventPeriod,
  defectDescriptionText,
  defectFixingPlanDate,
  locationDescription,
  inspectionEmployee,
}: SectionFourthControlProcedureProps) => {
  const beginDate = formatDatetime(controlEventPeriod?.beginDate) || "-";
  const endDate = formatDatetime(controlEventPeriod?.endDate) || "-";
  const periodString = `${beginDate} — ${endDate}`;

  return (
    <div className="section-fourth-control-procedure">
      <div className="section-fourth-control-procedure__section">
        <div className="section-fourth-control-procedure__title">
          Сведения о контрольной процедуре
        </div>

        <div className="section-fourth-control-procedure__table">
          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Сведения о проведении строительного контроля
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              {fallbackString(constructionControlInfo)}
            </Col>
          </Row>

          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Сроки проведения контрольного мероприятия
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              {fallbackString(periodString)}
            </Col>
          </Row>

          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Описание выявленных недостатков
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              {fallbackString(defectDescriptionText)}
            </Col>
          </Row>

          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Срок устранения (плановая дата устранения)
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              {fallbackString(formatDate(defectFixingPlanDate))}
            </Col>
          </Row>

          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Местоположение
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              {fallbackString(locationDescription)}
            </Col>
          </Row>

          <Row className="section-fourth-control-procedure__row">
            <Col span={8} className="section-fourth-control-procedure__label">
              Уполномоченный представитель по вопросам строительного контроля
            </Col>
            <Col span={16} className="section-fourth-control-procedure__text">
              <div className="journal-info-person-column">
                <UserBubble userId={inspectionEmployee?.inspectionEmployeeId}>
                  <div className="journal-info-person-name">
                    {`${inspectionEmployee?.surname || ""} ${
                      inspectionEmployee?.firstName?.[0] || ""
                    }.${inspectionEmployee?.middleName?.[0] || ""}`}
                  </div>
                </UserBubble>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
